import { ProfileIcon } from 'src/common/types';
import { routePathsById } from '../Routes/getRoutePath';
import { useLocationWithState } from '../Routes/useLocationWithState';
import { useNavigateWithHistory } from '../Routes/useNavigateWithHistory';
import { PROFILES_PATH } from '../Routes/routeNames';

export const useEditorState = (userId: string | undefined) => {
  const location = useLocationWithState();
  const navigate = useNavigateWithHistory();

  const currentEditorState = location.state.profileEditor || {
    displayName: null,
    icon: null,
  };

  const updateDisplayName = (newDisplayName: string) => {
    if (!userId) return;
    const newProfileEditState = {
      ...currentEditorState,
      displayName: newDisplayName,
    };
    navigate(
      { pathname: `${routePathsById.editProfile(userId)}` },
      {
        state: {
          profileEditor: newProfileEditState,
        },
      }
    );
  };

  const updateProfileIcon = (newIcon: ProfileIcon) => {
    if (!userId) return;
    navigate(
      { pathname: `${routePathsById.editProfile(userId)}` },
      { state: { profileEditor: { ...currentEditorState, icon: newIcon } } }
    );
  };

  const setIsEditing = (fieldName: string) => {
    if (!userId) return;
    navigate(
      { pathname: `${routePathsById.editProfile(userId, fieldName)}` },
      { state: { profileEditor: { ...currentEditorState } } }
    );
  };

  const closeNameEditor = () => {
    if (!userId) return;
    navigate(
      { pathname: `${routePathsById.editProfile(userId)}` },
      { state: { profileEditor: { ...currentEditorState, displayName: null } } }
    );
  };
  const clearUpdatedValues = () => {
    if (!userId) return;
    navigate(
      { pathname: `/${PROFILES_PATH}` },
      { state: { profileEditor: { displayName: null, icon: null } } }
    );
  };

  const displayName = currentEditorState?.displayName || null;
  const profileIcon = currentEditorState?.icon || null;

  return {
    updateDisplayName,
    displayName,
    updateProfileIcon,
    profileIcon,
    setIsEditing,
    closeNameEditor,
    clearUpdatedValues,
  };
};
